var modules_2529eb59 = {"container":"Footer_module_container__5196461d"};
import "../../assets/CmrkKM2Z.css";

export { modules_2529eb59 as default };
//# sourceMappingURL=Footer.module.less.js.map
